/**
 * A stable, opaque per-browser session id. Sent with every chat request for
 * rate-limiting and analytics correlation — never personal data. Persisted in
 * localStorage so a returning visitor keeps one conversation thread; falls back
 * to a per-page-load id when storage is unavailable (e.g. private mode).
 */
const STORAGE_KEY = 'sophia-ai-session';

let cached: string | null = null;

export function getSessionId(): string {
  if (cached !== null) {
    return cached;
  }

  cached = readOrCreate();
  return cached;
}

function readOrCreate(): string {
  try {
    const existing = localStorage.getItem(STORAGE_KEY);

    if (existing !== null && existing !== '') {
      return existing;
    }

    const id = crypto.randomUUID();
    localStorage.setItem(STORAGE_KEY, id);
    return id;
  } catch {
    // Storage blocked — use an ephemeral id for this page load.
    return crypto.randomUUID();
  }
}
